import { Minutes } from 'components/organisms/user-capacity';
import { ignoreMinutesIfZero } from '../../utils/dates';

interface Props {
  value: Minutes;
  percentage?: number;
  id: number | string;
}

export const demandEventTemplate = ({
  id,
  value,
  percentage,
}: Props): string => {
  return `<div class="content" data-event-id=${id}>${
    value === 0
      ? '-'
      : `${ignoreMinutesIfZero(value)}${
          percentage != null
            ? ` <span class="secondary-text">(${percentage}%)</span>`
            : ''
        }`
  }
  </div`;
};
